import styled, { css } from 'styled-components';
import React, { FC, ChangeEventHandler, SelectHTMLAttributes } from 'react';

import { Icon } from '../Icon';
import { mixinThemingShape, colors } from 'src/theme';

type Option = string | number | string[] | undefined;

interface SelectProps {
  options: Option[];
  value?: Option;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  isError?: boolean;
}

type CombinedSelectProps = SelectHTMLAttributes<HTMLSelectElement> & SelectProps; // prettier-ignore

export const Select: FC<CombinedSelectProps> = ({
  options = [],
  value,
  onChange,
  isError = false,
  ...props
}) => (
  <SelectWrapper>
    <SelectComponent
      value={value}
      onChange={onChange}
      {...props}
      isError={isError}
    >
      {options.map((option, i) => (
        <Option key={`${option}-${i}`} value={option}>
          {option}
        </Option>
      ))}
    </SelectComponent>
    <ArrowWrapper>
      <Icon name="chevron" size="small" />
    </ArrowWrapper>
  </SelectWrapper>
);

const SelectComponent = styled.select<{ isError: boolean }>`
  font: inherit;
  color: inherit;
  background-color: ${({ theme: { colors } }) => colors?.white};
  cursor: pointer;

  /*styled-components takes care of vendor prefixes  */
  appearance: none;

  &:hover {
    background-color: #f5f5f5;
  }

  /* Theming Overrides */
  ${mixinThemingShape('select', {
    border: `1px solid ${colors?.borderGray}`,
    padding: '0.5em 2.375em 0.5em 0.625em',
    borderRadius: '2px',
  })}

  ${({ isError }) =>
    isError &&
    css`
      border: 1px solid ${({ theme: { colors } }) => colors?.red};
    `};
`;

const Option = styled.option``;

const SelectWrapper = styled.div`
  position: relative;
  display: inline-block;
  ${({ theme }) => theme?.overrides?.Select}
`;

const ArrowWrapper = styled.div`
  position: absolute;
  top: 0.625em;
  right: 0.625em;
  pointer-events: none;
`;
